import { c as _c } from "react/compiler-runtime";
import { getOrgRolesOptions, postOrgApiKeysMutation } from '@onefootprint/fetch-dashboard';
import { getErrorMessage } from '@onefootprint/request';
import type { OrganizationRole } from '@onefootprint/request-types/dashboard';
import { Dialog, Form, useToast } from '@onefootprint/ui';
import { useMutation, useQuery } from '@tanstack/react-query';
import { FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import useInvalidateQueries from '@/hooks/use-invalidate-queries';
import Loading from './loading';
type CreateDialogProps = {
  open: boolean;
  onClose: () => void;
};
type FormData = {
  name: string;
  role: string;
};
const CreateDialog = t0 => {
  const $ = _c(127);
  const {
    open,
    onClose
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "create"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("api-keys", t1);
  const {
    toast
  } = useToast();
  const formMethods = useForm();
  const invalidateQueries = useInvalidateQueries();
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = getOrgRolesOptions({
      query: {
        kind: "api_key"
      }
    });
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const rolesQuery = useQuery(t2);
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = postOrgApiKeysMutation();
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const createApiKeyMutation = useMutation(t3);
  let T0;
  let T1;
  let T2;
  let t10;
  let t11;
  let t12;
  let t13;
  let t14;
  let t15;
  let t16;
  let t17;
  let t18;
  let t19;
  let t20;
  let t21;
  let t22;
  let t23;
  let t24;
  let t25;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[3] !== createApiKeyMutation || $[4] !== formMethods || $[5] !== invalidateQueries || $[6] !== onClose || $[7] !== open || $[8] !== rolesQuery.data?.data || $[9] !== rolesQuery.isPending || $[10] !== t || $[11] !== toast) {
    const possibleRoles = rolesQuery.data?.data.filter(_temp);
    let t26;
    if ($[37] !== formMethods || $[38] !== onClose) {
      t26 = () => {
        formMethods.reset();
        onClose();
      };
      $[37] = formMethods;
      $[38] = onClose;
      $[39] = t26;
    } else {
      t26 = $[39];
    }
    const handleClose = t26;
    let t27;
    if ($[40] !== createApiKeyMutation || $[41] !== handleClose || $[42] !== invalidateQueries || $[43] !== t || $[44] !== toast) {
      t27 = formData => {
        createApiKeyMutation.mutate({
          body: {
            name: formData.name,
            roleId: formData.role
          }
        }, {
          onSuccess: () => {
            toast({
              title: t(_temp2),
              description: t(_temp3)
            });
            invalidateQueries();
            handleClose();
          },
          onError: e => {
            toast({
              title: t(_temp4),
              description: getErrorMessage(e)
            });
          }
        });
      };
      $[40] = createApiKeyMutation;
      $[41] = handleClose;
      $[42] = invalidateQueries;
      $[43] = t;
      $[44] = toast;
      $[45] = t27;
    } else {
      t27 = $[45];
    }
    const handleBeforeSubmit = t27;
    T2 = Dialog;
    if ($[46] !== t) {
      t20 = t(_temp5);
      $[46] = t;
      $[47] = t20;
    } else {
      t20 = $[47];
    }
    if ($[48] !== t) {
      t21 = t(_temp6);
      $[48] = t;
      $[49] = t21;
    } else {
      t21 = $[49];
    }
    let t28;
    if ($[50] !== t) {
      t28 = t(_temp7);
      $[50] = t;
      $[51] = t28;
    } else {
      t28 = $[51];
    }
    const t29 = createApiKeyMutation.isPending;
    let t30;
    if ($[52] !== t) {
      t30 = t(_temp8);
      $[52] = t;
      $[53] = t30;
    } else {
      t30 = $[53];
    }
    if ($[54] !== createApiKeyMutation.isPending || $[55] !== t28 || $[56] !== t30) {
      t22 = {
        form: "create-secret-key-form",
        label: t28,
        loading: t29,
        loadingAriaLabel: t30,
        type: "submit"
      };
      $[54] = createApiKeyMutation.isPending;
      $[55] = t28;
      $[56] = t30;
      $[57] = t22;
    } else {
      t22 = $[57];
    }
    const t31 = createApiKeyMutation.isPending;
    let t32;
    if ($[58] !== t) {
      t32 = t(_temp9);
      $[58] = t;
      $[59] = t32;
    } else {
      t32 = $[59];
    }
    if ($[60] !== createApiKeyMutation.isPending || $[61] !== handleClose || $[62] !== t32) {
      t23 = {
        disabled: t31,
        label: t32,
        onClick: handleClose
      };
      $[60] = createApiKeyMutation.isPending;
      $[61] = handleClose;
      $[62] = t32;
      $[63] = t23;
    } else {
      t23 = $[63];
    }
    t24 = handleClose;
    t25 = open;
    T1 = FormProvider;
    t19 = formMethods;
    t15 = "create-secret-key-form";
    if ($[64] !== formMethods || $[65] !== handleBeforeSubmit) {
      t16 = formMethods.handleSubmit(handleBeforeSubmit);
      $[64] = formMethods;
      $[65] = handleBeforeSubmit;
      $[66] = t16;
    } else {
      t16 = $[66];
    }
    if ($[67] !== t) {
      t17 = t(_temp10);
      $[67] = t;
      $[68] = t17;
    } else {
      t17 = $[68];
    }
    t18 = "w-full";
    t12 = "grid grid-cols-1 md:grid-cols-[2fr_1fr] gap-5";
    let t33;
    if ($[69] !== t) {
      t33 = t(_temp11);
      $[69] = t;
      $[70] = t33;
    } else {
      t33 = $[70];
    }
    let t34;
    if ($[71] !== t) {
      t34 = t(_temp12);
      $[71] = t;
      $[72] = t34;
    } else {
      t34 = $[72];
    }
    let t35;
    if ($[73] !== t) {
      t35 = t(_temp13);
      $[73] = t;
      $[74] = t35;
    } else {
      t35 = $[74];
    }
    let t36;
    if ($[75] !== t35) {
      t36 = {
        required: t35
      };
      $[75] = t35;
      $[76] = t36;
    } else {
      t36 = $[76];
    }
    if ($[77] !== t33 || $[78] !== t34 || $[79] !== t36) {
      t13 = <Form.Input name="name" size="compact" label={t33} placeholder={t34} rules={t36} />;
      $[77] = t33;
      $[78] = t34;
      $[79] = t36;
      $[80] = t13;
    } else {
      t13 = $[80];
    }
    if ($[81] !== rolesQuery.isPending) {
      t14 = rolesQuery.isPending && <div className="flex-1 min-w-0"><Loading /></div>;
      $[81] = rolesQuery.isPending;
      $[82] = t14;
    } else {
      t14 = $[82];
    }
    t11 = "flex-1 min-w-0";
    T0 = Form.Select;
    t4 = "role";
    t5 = "compact";
    if ($[83] !== t) {
      t6 = t(_temp14);
      $[83] = t;
      $[84] = t6;
    } else {
      t6 = $[84];
    }
    if ($[85] !== t) {
      t7 = t(_temp15);
      $[85] = t;
      $[86] = t7;
    } else {
      t7 = $[86];
    }
    let t37;
    if ($[87] !== t) {
      t37 = t(_temp16);
      $[87] = t;
      $[88] = t37;
    } else {
      t37 = $[88];
    }
    if ($[89] !== t37) {
      t8 = {
        required: t37
      };
      $[89] = t37;
      $[90] = t8;
    } else {
      t8 = $[90];
    }
    t9 = possibleRoles?.find(_temp17)?.id;
    t10 = possibleRoles?.map(_temp18) || [];
    $[3] = createApiKeyMutation;
    $[4] = formMethods;
    $[5] = invalidateQueries;
    $[6] = onClose;
    $[7] = open;
    $[8] = rolesQuery.data?.data;
    $[9] = rolesQuery.isPending;
    $[10] = t;
    $[11] = toast;
    $[12] = T0;
    $[13] = T1;
    $[14] = T2;
    $[15] = t10;
    $[16] = t11;
    $[17] = t12;
    $[18] = t13;
    $[19] = t14;
    $[20] = t15;
    $[21] = t16;
    $[22] = t17;
    $[23] = t18;
    $[24] = t19;
    $[25] = t20;
    $[26] = t21;
    $[27] = t22;
    $[28] = t23;
    $[29] = t24;
    $[30] = t25;
    $[31] = t4;
    $[32] = t5;
    $[33] = t6;
    $[34] = t7;
    $[35] = t8;
    $[36] = t9;
  } else {
    T0 = $[12];
    T1 = $[13];
    T2 = $[14];
    t10 = $[15];
    t11 = $[16];
    t12 = $[17];
    t13 = $[18];
    t14 = $[19];
    t15 = $[20];
    t16 = $[21];
    t17 = $[22];
    t18 = $[23];
    t19 = $[24];
    t20 = $[25];
    t21 = $[26];
    t22 = $[27];
    t23 = $[28];
    t24 = $[29];
    t25 = $[30];
    t4 = $[31];
    t5 = $[32];
    t6 = $[33];
    t7 = $[34];
    t8 = $[35];
    t9 = $[36];
  }
  let t26;
  if ($[91] !== T0 || $[92] !== t10 || $[93] !== t4 || $[94] !== t5 || $[95] !== t6 || $[96] !== t7 || $[97] !== t8 || $[98] !== t9) {
    t26 = <T0 name={t4} size={t5} placeholder={t6} label={t7} rules={t8} defaultValue={t9} options={t10} />;
    $[91] = T0;
    $[92] = t10;
    $[93] = t4;
    $[94] = t5;
    $[95] = t6;
    $[96] = t7;
    $[97] = t8;
    $[98] = t9;
    $[99] = t26;
  } else {
    t26 = $[99];
  }
  let t27;
  if ($[100] !== t11 || $[101] !== t26) {
    t27 = <div className={t11}>{t26}</div>;
    $[100] = t11;
    $[101] = t26;
    $[102] = t27;
  } else {
    t27 = $[102];
  }
  let t28;
  if ($[103] !== t12 || $[104] !== t13 || $[105] !== t14 || $[106] !== t27) {
    t28 = <div className={t12}>{t13}{t14}{t27}</div>;
    $[103] = t12;
    $[104] = t13;
    $[105] = t14;
    $[106] = t27;
    $[107] = t28;
  } else {
    t28 = $[107];
  }
  let t29;
  if ($[108] !== t15 || $[109] !== t16 || $[110] !== t17 || $[111] !== t18 || $[112] !== t28) {
    t29 = <form id={t15} onSubmit={t16} aria-label={t17} className={t18}>{t28}</form>;
    $[108] = t15;
    $[109] = t16;
    $[110] = t17;
    $[111] = t18;
    $[112] = t28;
    $[113] = t29;
  } else {
    t29 = $[113];
  }
  let t30;
  if ($[114] !== T1 || $[115] !== t19 || $[116] !== t29) {
    t30 = <T1 {...t19}>{t29}</T1>;
    $[114] = T1;
    $[115] = t19;
    $[116] = t29;
    $[117] = t30;
  } else {
    t30 = $[117];
  }
  let t31;
  if ($[118] !== T2 || $[119] !== t20 || $[120] !== t21 || $[121] !== t22 || $[122] !== t23 || $[123] !== t24 || $[124] !== t25 || $[125] !== t30) {
    t31 = <T2 aria-label={t20} title={t21} primaryButton={t22} secondaryButton={t23} onClose={t24} open={t25}>{t30}</T2>;
    $[118] = T2;
    $[119] = t20;
    $[120] = t21;
    $[121] = t22;
    $[122] = t23;
    $[123] = t24;
    $[124] = t25;
    $[125] = t30;
    $[126] = t31;
  } else {
    t31 = $[126];
  }
  return t31;
};
export default CreateDialog;
function _temp(role) {
  return role.kind === "api_key";
}
function _temp2($) {
  return $.feedback.success.title;
}
function _temp3($_0) {
  return $_0.feedback.success.description;
}
function _temp4($_1) {
  return $_1.feedback.error.title;
}
function _temp5($_2) {
  return $_2.form.dialogAria;
}
function _temp6($_3) {
  return $_3.title;
}
function _temp7($_4) {
  return $_4.cta.label;
}
function _temp8($_5) {
  return $_5.cta.ariaLabel;
}
function _temp9($_6) {
  return $_6.cancel;
}
function _temp10($_7) {
  return $_7.form.aria;
}
function _temp11($_8) {
  return $_8.form.name.label;
}
function _temp12($_9) {
  return $_9.form.name.placeholder;
}
function _temp13($_10) {
  return $_10.form.name.errors.required;
}
function _temp14($_11) {
  return $_11.form.accessControl.placeholder;
}
function _temp15($_12) {
  return $_12.form.accessControl.label;
}
function _temp16($_13) {
  return $_13.form.accessControl.errors.required;
}
function _temp17(role_0) {
  return role_0.name === "Member";
}
function _temp18(role_1) {
  return {
    label: role_1.name,
    value: role_1.id
  };
}